import { AuditLogActorType, ContactType } from '../../generated/graphql';
import homecomingLogo from '../../assets/images/logo/logo-green-xl.png';
import { formatContactTypeLabel } from './patientContactLabels';

export type AuditActivityTeamMember = {
  name: string;
  subtitle: string | null;
  imageUrl?: string;
  isSystem: boolean;
  isExternal: boolean;
};

type ContactShareMetadata = {
  contact_name?: string | null;
  contact_email?: string | null;
  contact_type?: string | null;
};

type AuditActivityLike = {
  actorType?: AuditLogActorType | string | null;
  performedByProviderUser?: {
    name?: string | null;
    profileImageMedia?: { url: string } | null;
  } | null;
  extraMetadata?: ContactShareMetadata | null;
};

export const isSystemAuditActivity = (activity: AuditActivityLike): boolean =>
  activity.actorType === AuditLogActorType.System ||
  activity.actorType === 'System' ||
  activity.actorType === 'SYSTEM';

export const isExternalAuditActivity = (activity: AuditActivityLike): boolean =>
  activity.actorType === AuditLogActorType.External ||
  activity.actorType === 'External' ||
  activity.actorType === 'EXTERNAL';

export const formatContactShareLabel = (
  metadata?: ContactShareMetadata | null,
): string => {
  const name =
    metadata?.contact_name?.trim() ||
    metadata?.contact_email?.trim() ||
    'Contact';
  const typeLabel = metadata?.contact_type
    ? formatContactTypeLabel(metadata.contact_type as ContactType)
    : null;
  return typeLabel ? `${name} (${typeLabel})` : name;
};

export const getAuditActivityTeamMemberDisplay = (
  activity: AuditActivityLike,
): AuditActivityTeamMember => {
  if (isSystemAuditActivity(activity)) {
    return {
      name: 'Homecoming',
      subtitle: 'System action',
      imageUrl: homecomingLogo,
      isSystem: true,
      isExternal: false,
    };
  }

  if (isExternalAuditActivity(activity)) {
    return {
      name: formatContactShareLabel(activity.extraMetadata),
      subtitle: 'External contact',
      isSystem: false,
      isExternal: true,
    };
  }

  return {
    name: activity.performedByProviderUser?.name ?? 'Unknown user',
    subtitle: null,
    imageUrl: activity.performedByProviderUser?.profileImageMedia?.url,
    isSystem: false,
    isExternal: false,
  };
};
